module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width a-table--hover",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("General Damages (PSLA)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamages'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('generalDamagesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Funeral Expenses")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpenses'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('funeralExpensesWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loss of Spouse")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouse'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('lossOfSpouseWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Travel")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravel'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfTravelWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('misc'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('miscWithInterest'))))])]), _vm._v(" "), _vm._l((_vm.customHeadsOfLoss), function(customHead) {
    return (_vm.customHeadsOfLoss.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(customHead.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(customHead.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(customHead.interestAccrued)))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Loss of Earnings")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarnings'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastLossOfEarningsWithInterest'))))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Past Cost of Care")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCare'))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.headOfLoss('pastCostOfCareWithInterest'))))])]), _vm._v(" "), (_vm.cruTotalDeductions > 0) ? _c('tr', [_c('td', [_vm._v("CRU Benefit Deductions")]), _vm._v(" "), _c('td', [_vm._v("- " + _vm._s(_vm.currencyFormat(_vm.cruTotalDeductions)))]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', [_vm._v("Subtotal")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestTotal)))])]), _vm._v(" "), (_vm.interimPayments.length > 0) ? _c('tr', {
    staticClass: "a-table--penultimate"
  }, [_c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.total)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total "), (_vm.interimPayments.length > 0) ? _c('span', [_vm._v("less interim payment(s)")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalLessInterimPayments)))])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "step-button flex-state-buttons flex-state-buttons--block a-table--center"
  }, [_c('div', [_c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'fatal::estate.step-5'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Back\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "a-button",
    attrs: {
      "to": {
        name: 'fatal::estate.documents.list',
        params: {
          id: _vm.claimId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n                View Documents\n            ")])], 1)]), _vm._v(" "), _c('reserves-for-claim')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Heads of Loss")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Amount")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "33%"
    }
  }, [_c('h2', [_vm._v("Interest")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54049980!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/estate/steps/CalculateLossAndGenerateSchedule.vue
// module id = 1693
// module chunks = 0